var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlansImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 48H42.6667C44.0812 48 45.4377 47.4381 46.4379 46.4379C47.4381 45.4377 48 44.0812 48 42.6667V5.33333C48 3.91885 47.4381 2.56229 46.4379 1.5621C45.4377 0.561903 44.0812 0 42.6667 0H5.33333C3.91885 0 2.56229 0.561903 1.5621 1.5621C0.561903 2.56229 0 3.91885 0 5.33333V42.6667C0 44.0812 0.561903 45.4377 1.5621 46.4379C2.56229 47.4381 3.91885 48 5.33333 48ZM13.3333 29.3333L19.6347 35.6347L29.3333 21.3333L42.6667 40H5.33333L13.3333 29.3333Z",
    fill: "#B5B1CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansImage);
export default __webpack_public_path__ + "static/media/plansImage.b5684c6460d8ad97c3de0c956196eef1.svg";
export { ForwardRef as ReactComponent };